@if (isDevMode) {
    <section class="cms-unknown tg-container">
        <p class="cms-unknown__type">{{ section().__typename }}</p>
        @if (message(); as text) {
            <p class="cms-unknown__message">{{ text }}</p>
        } @else {
            <p class="cms-unknown__message">No component registered for this section type.</p>
        }
    </section>
}
